module.exports = __webpack_public_path__ + "static/refactoring-19f1538c390fd4eb0dfe3bfc946924cf.jpeg";